import React, { FunctionComponent } from 'react'
import { Button, ButtonProps, Grid, Text, Theme, useIsTheme } from '@afterpaytouch/core'
import { useTranslation } from '../../../utils/convergence'
import { BASE_PATH } from '../../../env'
import { useCheckoutSizes } from '../../../utils/responsive'
import { useShowBiometricsButton } from '../../../state'
import Image from 'next/image'

interface BiometricButtonProps extends ButtonProps {
  submitted: boolean
}

export const BiometricButton: FunctionComponent<BiometricButtonProps> = ({ onClick, submitted }) => {
  const { t } = useTranslation()
  const { buttonSize } = useCheckoutSizes()
  const isAPTheme = useIsTheme(Theme.AP)
  const showBiometricButton = useShowBiometricsButton()
  const biometricBlackImgSrc = [BASE_PATH, 'images/bio-black.gif'].join('/')
  const testNameSpace = 'explicit-biometric-login'

  const showBiometricImage = isAPTheme && !submitted
  if (!showBiometricButton) {
    return null
  }

  return (
    <Grid.Item sm={12}>
      <Button.Secondary onClick={onClick} size={buttonSize} testNameSpace={testNameSpace} disabled={submitted} padding='Fluid'>
        <>
          {showBiometricImage && (
            <Image
              src={biometricBlackImgSrc}
              data-testid='reinitiate-biometric-black-button'
              alt='reinitiate-biometrics-black-button'
              width='25'
              height='25'
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          )}
          <Text bold size='S' testNameSpace={testNameSpace}>
            {t('password:loginWithBiometricButton')}
          </Text>
        </>
      </Button.Secondary>
    </Grid.Item>
  )
}
